import { Action, Dispatch } from 'redux';
import { ReduxAction, pending, failure, success } from '../../core';

import { HealAPI } from '../../../healApi';
import { OnSiteVisit } from './types';
import { ThunkAction } from 'redux-thunk';
import { TimeSlot } from '../../visits/types';
import { toast } from '../../message/actions';

export enum OnSiteVisitsAction {
  SET_ONSITE_IS_FETCHING = 'ON_SITE_VISITS_SET_ONSITE_IS_FETCHING',
  SET_ONSITE_VISITS = 'ON_SITE_VISITS_SET_ONSITE_VISITS',
  SET_ONSITE_VISIT = 'ON_SITE_VISITS_SET_ONSITE_VISIT',
  FETCH_ONSITE_VISIT = 'ON_SITE_VISITS_FETCH_ONSITE_VISIT',

  SET_AVAILABLE_ONSITE_TIME_SLOTS = 'ON_SITE_VISITS_SET_AVAILABLE_ONSITE_TIME_SLOTS',
  SET_AVAILABLE_ONSITE_TIME_SLOTS_FETCHING = 'ON_SITE_VISITS_SET_AVAILABLE_ONSITE_TIME_SLOTS_FETCHING',

  UPDATE_TIME = 'ON_SITE_VISITS_UPDATE_TIME',
}

export function setOnSiteVisitsFetching(value: boolean): ReduxAction<boolean> {
  return {
    type: OnSiteVisitsAction.SET_ONSITE_IS_FETCHING,
    data: value,
  };
}

export function setOnSiteVisits(value: OnSiteVisit[]): ReduxAction<OnSiteVisit[]> {
  return {
    type: OnSiteVisitsAction.SET_ONSITE_VISITS,
    data: value,
  };
}

export function setOnSiteVisit(value: OnSiteVisit): ReduxAction<OnSiteVisit> {
  return {
    type: OnSiteVisitsAction.SET_ONSITE_VISIT,
    data: value,
  };
}

export function fetchOnSiteVisit(visitCode: string, refresh?: boolean): ReduxAction<{ visitCode: string; refresh?: boolean }> {
  return {
    type: OnSiteVisitsAction.FETCH_ONSITE_VISIT,
    data: {
      visitCode,
      refresh,
    },
  };
}

export function setAvailableOnSiteTimeSlotsFetching(value: boolean): ReduxAction<boolean> {
  return {
    type: OnSiteVisitsAction.SET_AVAILABLE_ONSITE_TIME_SLOTS_FETCHING,
    data: value,
  };
}

export function setAvailableOnSiteTimeSlots(value: TimeSlot[]): ReduxAction<{ value: TimeSlot[] }> {
  return {
    type: OnSiteVisitsAction.SET_AVAILABLE_ONSITE_TIME_SLOTS,
    data: {
      value,
    },
  };
}

export function updateTime(visitCode: string, timeSlotId: string): ThunkAction<any, any, any, any> {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: pending(OnSiteVisitsAction.UPDATE_TIME) });
    return HealAPI.updateTime(visitCode, timeSlotId)
      .then((response) => {
        if (response.ok) {
          dispatch(
            toast({
              type: 'success',
              title: 'Success',
              content: 'This visit has been successfully rescheduled.',
            })
          );
          dispatch({ type: success(OnSiteVisitsAction.UPDATE_TIME), data: response.data });
        } else {
          dispatch(toast({ type: 'error', title: 'Error', content: 'Could not connect to server' }));
          dispatch({ type: failure(OnSiteVisitsAction.UPDATE_TIME), data: response.data });
        }
      })
      .catch((error) => {
        dispatch(
          toast({
            type: 'error',
            title: 'Error',
            content: error.response.body || 'This visit could not be rescheduled.',
          })
        );
        dispatch({ type: failure(OnSiteVisitsAction.UPDATE_TIME), data: error });
      });
  };
}
